module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isLoadingData) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('h3', [_vm._v("Últimas Inscrições")]), _vm._v(" "), _c('table', {
    staticClass: "custom-table-list"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Pessoa")]), _vm._v(" "), _c('th', [_vm._v("Data da Inscrição")]), _vm._v(" "), _c('th', [_vm._v("Instituição")]), _vm._v(" "), _c('th', [_vm._v("Status da Inscrição")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.registrations), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.person.pessoa.id) + " - " + _vm._s(item.person.pessoa.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(item.created_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.institution.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.status.name))])])
  }))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('h3', [_vm._v("Últimas Submissões")]), _vm._v(" "), _c('table', {
    staticClass: "custom-table-list"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Autor")]), _vm._v(" "), _c('th', [_vm._v("Data da Submissão")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.papers), function(item) {
    return _c('tr', [_c('td', [_vm._v("\n                        " + _vm._s(item.registration.person.ref_pessoa) + " - " + _vm._s(item.registration.person.pessoa.nome) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(item.date_submitted)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.status.name))])])
  }))])])], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-60383460!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/event/components/show/Home.vue
// module id = 756
// module chunks = 2